var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 0C13.4278 0.105503 10.7611 0.158255 8 0.158255C5.2389 0.158255 2.57223 0.105503 3.00146e-07 6.00293e-07L0 1.78036C2.57223 1.67486 5.2389 1.62211 8 1.62211C10.7611 1.62211 13.4278 1.67486 16 1.78036V0Z","fill":"black"}));
}

MinusInline.defaultProps = {"width":"16","height":"2","viewBox":"0 0 16 2","fill":"none"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
